import { roles } from 'common-src/models/Client/constants';
import { allModelsSelector, singleModelSelector } from 'common-src/utils/selectorUtils';

import { OncehubBookingStatuses } from './constants';

export const getPatientOncehubBookings = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientOncehubBooking',
    (booking) => booking.patientId === patientId,
  ).sort((a, b) => new Date(b.scheduledAt) - new Date(a.scheduledAt));

export const getPatientOncehubBookingByClientRole = (state, patientId, rolesIds = []) =>
  allModelsSelector(state, 'PatientOncehubBooking', (booking) => {
    const client = singleModelSelector(state, 'Client', booking.clientId);
    return booking.patientId === patientId && rolesIds.includes(client?.roleId);
  }).sort((a, b) => new Date(b.scheduledAt) - new Date(a.scheduledAt));

export const getCompletedPatientOncehubBookingsByNeurologist = (state, patientId) =>
  getPatientOncehubBookingByClientRole(state, patientId, [roles.Neurologist.id]).filter(
    (booking) =>
      ![OncehubBookingStatuses.canceled.value, OncehubBookingStatuses.missed.value].includes(
        booking.status,
      ),
  );
